// @ts-nocheck

import MainDispatcher from '../support/MainDispatcher';
import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';
import type { BranchExportPayload } from '../types/customExportTypes';
const EXPORT_PATH = '/v1/branch-custom-export';
const CreateBranchCustomExport = new ReduxAsyncAction('CREATE_BRANCH_CUSTOM_EXPORT');
CreateBranchCustomExport.registerRequest((params: BranchExportPayload) => {
  return dash_api
    .post(EXPORT_PATH, params)
    .then(({ data }) => data)
    .catch(() =>
      MainDispatcher.dispatch({
        action: 'EXPORT_CREATION_ERROR',
        error: 'Error creating export.',
      })
    );
});
export const CREATE_BRANCH_CUSTOM_EXPORT = CreateBranchCustomExport.constants;
export const createBranchCustomExport = CreateBranchCustomExport.request;
const RetrieveBranchCustomExports = new ReduxAsyncAction('RETRIEVE_BRANCH_CUSTOM_EXPORTS');
RetrieveBranchCustomExports.registerRequest(() => {
  return dash_api
    .get(EXPORT_PATH)
    .then(({ data }) => data)
    .catch(() =>
      MainDispatcher.dispatch({
        action: 'EXPORT_RETRIEVAL_ERROR',
        error: 'Error retrieving exports.',
      })
    );
});
export const RETRIEVE_BRANCH_CUSTOM_EXPORTS = RetrieveBranchCustomExports.constants;
export const retrieveBranchCustomExports = RetrieveBranchCustomExports.request;
